import {FormDrawer} from "./FormDrawer.tsx";
import {DrawerProps} from "@mantine/core";
import {useMeter} from "../hooks/useMeter.ts";
import {
    Meter,
    MeterAggregation,
    MeterGrain,
    MeterPurpose,
    MeterResetPolicy,
    MeterStatus
} from "../types.ts";

export const AddFormDrawer = (props: DrawerProps) => {
    const {
        createMutation,
    } = useMeter();

    // mutateAsync, not mutate: the drawer must know whether the create succeeded. The
    // mutation's own onError already notifies, so a failure only needs to keep it open.
    const handleSubmit = async (values: Meter) => {
        try {
            await createMutation.mutateAsync(values);
            return true;
        } catch {
            return false;
        }
    };

    return (
        <FormDrawer
            record={{
                id: '',
                name: '',
                meterCode: '',
                aggregation: MeterAggregation.COUNT,
                grain: MeterGrain.HOUR,
                unit: '',
                resetPolicy: MeterResetPolicy.NEVER,
                purpose: MeterPurpose.BILLABLE,
                latenessWindowMinutes: 1440,
                watermarkDelayMinutes: 15,
                status: MeterStatus.DRAFT,
                dimensions: [],
            } as Meter}
            handleSubmit={handleSubmit}
            {...props}
        />
    )
};
